const stateKey = (type) => `security-${type}-users-list`;
const restoreKey = (type) => `security-${type}-users-restore`;

export const saveUserListState = (type, state) => {
  sessionStorage.setItem(stateKey(type), JSON.stringify(state));
};

export const requestUserListRestore = (type) => {
  sessionStorage.setItem(restoreKey(type), "true");
};

export const restoreUserListState = (type) => {
  const shouldRestore = sessionStorage.getItem(restoreKey(type)) === "true";
  sessionStorage.removeItem(restoreKey(type));
  const stored = sessionStorage.getItem(stateKey(type));
  sessionStorage.removeItem(stateKey(type));
  if (!shouldRestore || !stored) return null;
  try {
    return JSON.parse(stored);
  } catch {
    return null;
  }
};
